import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Brand } from '../../models/brand';
import { map } from 'rxjs/operators';
import { BrandBuilder } from '../../models/builders/brand.builder';

const getBrandBody = (brand: Brand, file: File, bwFile: File) => {
  const postBody = new FormData();
  postBody.append('file', file);
  postBody.append('bwFile', bwFile);
  postBody.append('name', brand.name);

  return postBody;
};

@Injectable()
export class BrandApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }brands`;
  }

  createBrand(brand: Brand, file: File, bwFile: File) {
    return this.httpClient.post(this.apiUrl, getBrandBody(brand, file, bwFile)).pipe(map(BrandBuilder.fromJson));
  }

  deleteBrand(brand: Brand) {
    return this.httpClient.delete(`${ this.apiUrl }/${ brand.hash }`);
  }

  getBrand(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(BrandBuilder.fromJson)
      );
  }

  getBrands() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(BrandBuilder.fromList));
  }

  updateBrand(brand: Brand, file: File, bwFile: File) {
    return this.httpClient.put(`${ this.apiUrl }/${ brand.hash }`, getBrandBody(brand, file, bwFile));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/brand-api.service.ts